/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClientsControllerRemoveMutationResponse, ClientsControllerRemovePathParams, ClientsControllerRemove401, ClientsControllerRemove403, ClientsControllerRemove404 } from "../../models/clientsController/ClientsControllerRemove";

function getClientsControllerRemoveUrl(id: ClientsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/clients/${id}` as const }  
  return res
}

/**
 * @summary Delete a client
 * {@link /api/v1/clients/:id}
 */
export async function clientsControllerRemove(id: ClientsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ClientsControllerRemoveMutationResponse, ResponseErrorConfig<ClientsControllerRemove401 | ClientsControllerRemove403 | ClientsControllerRemove404>, unknown>({ method : "DELETE", url : getClientsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}